<template>
    <div>
        <div class="infos" v-if="infos.channels.length > 0">
            <div id="channels" v-if="infos.channels.length">
                Related：
                <template v-for="channels in infos.channels">
                    <a v-html="channels.tag" :href="isInApp ? channels.href : 'javascript:void(0);'"
                       :key="channels.tag"></a>
                </template>
            </div>
        </div>
        <div v-else style="height: 10px"></div>
        <div class="column-ad" v-if="infos.column.id">
            <a :href="isInApp ? infos.column.href : 'javascript:void(0);'"><img
                :src="getImgSrc(infos.column.show_footer_image)"/></a>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';

    export default {
        name: 'infos',
        data () {
            return {
                isInApp: process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
            };
        },
        props: ['infos']
    };
</script>
<style>
    .infos {
        margin: 0 15px 0;
        padding: 0;
    }

    .infos p {
        margin: 5px 0;
    }

    #channels {
        padding: 5px 0 34px;
        font-size: 13px;
        color: #8c9399;
        line-height: 34px;
    }

    #channels a {
        display: inline-block;
        position: relative;
        bottom: 2px;
        padding: 4px 8px;
        margin: 0 5px 0 0;
        line-height: 16px;
        background: #eff1f4;
        border-radius: 2px;
        vertical-align: middle;
        height: 16px;
        color: #606369;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .column-ad {
        margin: 0 15px 29px;
    }

    .column-ad a {
        display: block;
        width: 100%;
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        user-select: none;
    }

    .column-ad img {
        width: 100%;
        margin: 0;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// infos.vue?d508367c